export const IDENTITY_PROVIDERS = ["KCP", "KG_INICIS"] as const;

export type IdentityProvider = (typeof IDENTITY_PROVIDERS)[number];

export const IDENTITY_PROVIDER_LABELS: Record<IdentityProvider, string> = {
  KCP: "휴대폰 본인인증",
  KG_INICIS: "민간인증서",
};

export function isIdentityProvider(value: unknown): value is IdentityProvider {
  return IDENTITY_PROVIDERS.includes(value as IdentityProvider);
}
